import { Component, Input, OnChanges } from '@angular/core';
import { AutocompleteFilter } from '@models/filter-types';
import { LookupItem, StringLookupItem } from '@models/lookup';
import { getDisplayText, segmentTrack } from '@shared/helpers/functions/helpers';
import { Router } from '@angular/router';
import { MAT_AUTOCOMPLETE_DEFAULT_OPTIONS } from '@angular/material/autocomplete';
import { FilterInputErrorStateMatcher } from '@shared/components/filters/filter-input-error-state-matcher';

@Component({
    selector: 'app-autocomplete',
    templateUrl: './autocomplete.component.html',
    styleUrls: ['./autocomplete.component.scss'],
    providers: [{ useValue: { overlayPanelClass: 'select-overlay' }, provide: MAT_AUTOCOMPLETE_DEFAULT_OPTIONS }],
    standalone: false,
})
export class AutocompleteComponent implements OnChanges {
    @Input() property!: AutocompleteFilter<StringLookupItem | LookupItem>;
    @Input() overrideDisabled!: boolean;
    @Input() showErrorsAfterInteraction = false;

    disabled = false;
    errorStateMatcher!: FilterInputErrorStateMatcher<unknown>;

    constructor(private router: Router) {}

    ngOnChanges() {
        this.disabled = this.property?.isReadonly || this.overrideDisabled;
        this.errorStateMatcher = new FilterInputErrorStateMatcher(this.property, this.showErrorsAfterInteraction);
    }

    displayFn(option: { name: string } | string): string {
        if (typeof option === 'string') {
            return option;
        }
        return option?.name ?? '';
    }

    onReset(event: MouseEvent) {
        event.stopPropagation();
        this.property.onReset();
    }

    openedChange() {
        this.property.isOpened = true;
    }

    closedChange() {
        this.property.isOpened = false;
        // This forces a cascade update
        segmentTrack('User Selected From Dropdown', {
            dropdown: this.property.Key,
            selection: getDisplayText(this.property.Value),
            screen: this.router.url,
        });
    }
}
